import { Table } from "antd";
import { EndStepSummary } from "components/CC/RunHistory/StepDetails/utils/types";
import { DrawerCollapsible } from "components/UI/DrawerCollapsible/DrawerCollapsible";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";

import type { ColumnsType } from "antd/es/table";

interface EndRow {
    key: string;
    label: string;
    value: string;
}

export interface StepDetailEndProps {
    extractedData: EndStepSummary;
}

export const StepDetailEnd: FC<StepDetailEndProps> = ({ extractedData }) => {
    const { t } = usePaldockTranslation("drawers.step-detail.end");

    const rows: EndRow[] = [
        {
            key: "result",
            label: t("result"),
            value: extractedData.result ?? "-",
        },
    ];

    const columns: ColumnsType<EndRow> = [
        { dataIndex: "label", key: "label" },
        { dataIndex: "value", key: "value" },
    ];

    return (
        <DrawerCollapsible title={t("data")}>
            <Table
                columns={columns}
                dataSource={rows}
                pagination={false}
                size="small"
                bordered={false}
                showHeader={false}
            />
        </DrawerCollapsible>
    );
};
